import { handleGetRequest, handlePostRequest } from "../hooks/api";

export async function getQuestions(geohash) {
  let endpoint = "/questions";
  if (geohash) {
    endpoint = endpoint + "?geohash=" + geohash;
  }
  const response = await handleGetRequest(endpoint, undefined);
  if (response?.error) {
    throw new Error("Error while fetching questions", response?.error);
  }
  return response;
}

export async function getSuggestions(question_id, partial_text) {
  if (partial_text.trim() === "") return;
  let endpoint = `/suggestions?question_id=${question_id}&partial_text=${partial_text}`;
  const response = await handleGetRequest(endpoint, {});
  if (response?.error) {
    throw new Error("Error while fetching questions", response?.error);
  }
  return response;
}

export async function submitPollResponse(payload) {
  let endpoint = `/responses`;
  const response = await handlePostRequest(endpoint, payload, undefined);
  if (response?.error) {
    throw new Error("Error while submiting question response", response?.error);
  }
  return response;
}
export async function getPollStatitics(question_id) {
  let endpoint = `/stats?question_id=${question_id}`;
  const response = await handleGetRequest(endpoint);
  if (response?.error) {
    throw new Error("Error while getting poll statitics response", response?.error);
  }
  return response;
}
